export const DEFAULT_HOURLY_RATE = 35;

export const fmtUSD = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n));
};

export const fmtPct = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "0.0%";
  return `${(Number(n) * 100).toFixed(1)}%`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const fmtDateShort = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

export const isSameDay = (a, b) => {
  const da = new Date(a);
  const db = new Date(b);
  return (
    da.getFullYear() === db.getFullYear() &&
    da.getMonth() === db.getMonth() &&
    da.getDate() === db.getDate()
  );
};

export const daysFromNow = (iso, days) => {
  const target = new Date();
  target.setDate(target.getDate() + days);
  return isSameDay(iso, target);
};

export function computeRecipe(recipe, hourlyRate = DEFAULT_HOURLY_RATE) {
  const flowers = recipe?.flowers || [];
  const supplies = recipe?.supplies || [];
  const minutes = Number(recipe?.designerMinutes || 0);
  const rate = Number(recipe?.hourlyRate ?? hourlyRate);
  const sellingPrice = Number(recipe?.sellingPrice || 0);

  const flowersCost = flowers.reduce(
    (s, f) => s + Number(f.qty || 0) * Number(f.costPerStem || 0),
    0
  );
  const suppliesCost = supplies.reduce((s, x) => s + Number(x.cost || 0), 0);
  const recipeCost = flowersCost + suppliesCost;
  const laborCost = (minutes / 60) * rate;
  const totalCost = recipeCost + laborCost;
  const grossProfit = sellingPrice - totalCost;
  const grossMargin = sellingPrice > 0 ? grossProfit / sellingPrice : 0;

  return {
    flowersCost,
    suppliesCost,
    recipeCost,
    laborCost,
    totalCost,
    grossProfit,
    grossMargin,
    sellingPrice,
  };
}

export function computeQuotationTotals(lineItems) {
  return (lineItems || []).reduce(
    (acc, li) => {
      const qty = Number(li.qty || 0);
      const price = Number(li.sellingPrice || 0) * qty;
      const cost = Number(li.totalCost || 0) * qty;
      acc.selling += price;
      acc.cost += cost;
      return acc;
    },
    { selling: 0, cost: 0 }
  );
}

export const uid = (p = "id") =>
  `${p}_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;
